import { awsApiInstance } from '../api/aws-api';
import useAuth from '../hooks/auth-hooks';

import { IPostTax, IPostTaxResponse } from '../models/taxes.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Posts new tax data
 * 
 * @param {IPostTax} tax the form data
 * 
 * @returns {IPostTaxResponse} the api response | error 
 */
const PostNewTax = async (tax: IPostTax): Promise<IPostTaxResponse> => {
  try {
    const { userId } = useAuth()!;

    const modelData = {
      wpID: userId,
      taxName: tax.taxName,
      taxAmount: tax.taxAmount,
      taxType: tax.taxType,
      partnerID: tax.partnerID
    };

    const { data } = await awsApiInstance.post('/taxes', modelData );

    return data;
  } catch ( error ) {
    handleRouteError(error, 'Error post new tax');
    throw(error);
  }
}

export default PostNewTax;